package com.islamicmedia.shared.domain.model

/**
 * Verdict wording for a finished analysis.
 *
 * Deliberately DESCRIPTIVE ("Major Concerns") rather than a judgement on the work itself
 * ("Not Safe to Consume"). The label reports what our analysis found; it makes no factual claim
 * about the title being harmful, which is both more honest and far less defamatory.
 *
 * The Minor/Moderate/Major scale deliberately mirrors the per-concern severity badges
 * (Mild/Moderate/Critical) so the page speaks one vocabulary.
 *
 * A perfect score with nothing tagged gets its own wording — plenty of Islamic titles legitimately
 * have zero concerns, and calling those "Minor Concerns" understates them.
 *
 * Shared so web, mobile, the grid cards and the filter pills can never drift apart.
 */
fun verdictLabel(score: Int?, concernCount: Int, short: Boolean = false): String? {
    if (score == null) return null
    return when {
        score >= 10 && concernCount == 0 -> if (short) "None" else "No Concerns"
        score >= 7 -> if (short) "Minor" else "Minor Concerns"
        score >= 4 -> if (short) "Moderate" else "Moderate Concerns"
        else -> if (short) "Major" else "Major Concerns"
    }
}
